<template>
  <div>
    <div class="content">
      <div class="all">
        <div class="SearchBar">
        <el-form :inline="true" class="searchBoxForm">
         
          <el-form-item label="年份:" class="searchItem">
            <el-date-picker
              size="mini"
              v-model="year"
              type="year"
              value-format="yyyy"
              placeholder="选择年">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="" class="searchItem">
             <el-button type="primary" @click="search" size="mini" >查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      </div>
      <div class="contain">
        <el-table
            ref="tableData"
            :data="tableData"
            style="width: 100%;margin-top: 10px ;"
            border
            height="600px"
            show-summary
            :header-cell-style="{
							color: '#333',
							fontFamily: 'MicrosoftYaHeiUI',
							fontSize: '14px',
							fontWeight: 900,
							background: '#f8f8f9',
						}"
            :stripe="true"
          >
           
             <el-table-column :resizable="false" v-for="item in headerData" :key="item.key" :label="item.name" :prop="item.key" align="center">
                <template slot-scope="scope">
                  {{ scope.row[item.key] }}
                </template>
              </el-table-column>
         
        </el-table>
   
    </div>
    </div>
  </div>
</template>

<script>
import {inspectorStatistics} from "../../RequestPort/staticisc";
export default {
  data() {
    return {
      year:'',
      total:null,
      headerData:[
        {key:'inspector',name:'安检员'},
        {key:'january',name:'1月'},
        {key:'february',name:'2月'},
        {key:'march',name:'3月'},
        {key:'april',name:'4月'},
        {key:'may',name:'5月'},
        {key:'june',name:'6月'},
        {key:'july',name:'7月'},
        {key:'august',name:'8月'},
        {key:'september',name:'9月'},
        {key:'october',name:'10月'},
        {key:'november',name:'11月'},
        {key:'december',name:'12月'},
        {key:'aggregate',name:'总计'},
        ],//[{id:1,stationName:'XX站',children:[{key:'yjc',name:'已检查数'},{key:'yjc2',name:'已完成数'}]},{id:2,stationName:'XX站',children:[{key:'yjc',name:'已检查数'},{key:'yjc2',name:'已完成数'}]}],
      tableData: [{inspector:'1月',january:20}], //  表格数据
      title:''
    };
  },
  mounted() {
  
			
		const date = new Date()
		this.year=date.getFullYear().toString()
    this.loadList()
  },
  methods: {
    
    search() {
      this.loadList();
    },

    loadList(){
      inspectorStatistics({years:this.year}).then(res=>{       
        this.tableData =res.data
      })
    },
   
    
  },
};
</script>

<style lang="scss" scoped>
.SearchBar .el-form, .searchBox .el-form{
width: auto;
}
.searchBox {
  .searchBoxForm {
    display: flex;
    align-items: center;
  }
}
.tableTool{    
  height: 25px;
}
.searchItem {
  margin-bottom: 1%;
  margin-left: 1%;
}
.label {
  color: #909399;
}
.content-item {
  color: #444444;
}
.SearchBar {
  border-radius: 5px;
  margin: 10px;
  padding-top: 1%;
  background-color: #ffffff;
}
.all {
  background-color:#f3f4f8;height:auto
}
.content {
  background: #f3f4f8;
  width: 100%;
  border-radius: 6px;
  overflow:auto;
  height: calc(100vh - 120px);
}
.search{
  width: 190px;
}
.contain{
  height: 677px;
}
.total{
  margin-left: 15px;
  margin-top: 10px;
}
.table{
  overflow:auto;
  height: 520px;
}
</style>